/**
 * OAM module route definitions.
 *
 * Sprint OAM-M1-7. Discovered by src/routes/index.tsx via
 * an import.meta.glob call over modules/[slug]/routes.tsx.
 */
import { lazy } from 'react';
import { registerFormFieldRenderer } from '@/modules/elc/formFieldRenderers';

const HardwareList = lazy(() => import('./pages/HardwareList'));
const HardwareDetail = lazy(() => import('./pages/HardwareDetail'));
const CategoryAdmin = lazy(() => import('./pages/CategoryAdmin'));
const HardwareModelAdmin = lazy(() => import('./pages/HardwareModelAdmin'));
const OamManufacturerAdmin = lazy(() => import('./pages/OamManufacturerAdmin'));
const OamSpecCatalogAdmin = lazy(() => import('./pages/OamSpecCatalogAdmin'));
const OamCompatRulesAdmin = lazy(() => import('./pages/OamCompatRulesAdmin'));
const StatusLabelAdmin = lazy(() => import('./pages/StatusLabelAdmin'));
const KitsAdmin = lazy(() => import('./pages/KitsAdmin'));
const OfficeAdmin = lazy(() => import('./pages/OfficeAdmin'));
const ConsumablesList = lazy(() => import('./pages/ConsumablesList'));
const AccessoriesList = lazy(() => import('./pages/AccessoriesList'));
const LicensesList = lazy(() => import('./pages/LicensesList'));
const AuditRuns = lazy(() => import('./pages/AuditRuns'));
const HardwareImport = lazy(() => import('./pages/HardwareImport'));

export const slug = 'oam';

// Owner 2026-10-24 — ELC forms' "Assigned desk" gets the desk map picker.
registerFormFieldRenderer('desk_ref', lazy(() => import('./components/DeskMapPicker')));
// …and "Additional desks" (one per other office) gets the multi-desk picker.
registerFormFieldRenderer('desk_refs', lazy(() => import('./components/DeskMapPicker')
  .then((m) => ({ default: m.AdditionalDeskMapPicker }))));

export const routes = [
  { path: 'hardware', element: HardwareList },
  { path: 'hardware/:id', element: HardwareDetail },
  { path: 'kits', element: KitsAdmin },
  { path: 'office', element: OfficeAdmin },
  { path: 'office/building/:buildingId', element: OfficeAdmin },
  { path: 'office/building/:buildingId/floor/:floorId', element: OfficeAdmin },
  { path: 'consumables', element: ConsumablesList },
  { path: 'accessories', element: AccessoriesList },
  { path: 'licenses', element: LicensesList },
  { path: 'audits', element: AuditRuns },
  { path: 'import', element: HardwareImport },
  { path: 'admin/categories', element: CategoryAdmin },
  { path: 'admin/models', element: HardwareModelAdmin },
  { path: 'admin/manufacturers', element: OamManufacturerAdmin },
  { path: 'admin/spec-catalog', element: OamSpecCatalogAdmin },
  { path: 'admin/compat-rules', element: OamCompatRulesAdmin },
  { path: 'admin/status-labels', element: StatusLabelAdmin },
];
